import {
  LINKS_LIST,
  UPDATE_LINK,
  ADD_LINK,
  REMOVE_LINK,
  MOVE_LINK,
  MOVE_LINK_ERROR,
} from './types';

// Copy from react-beautiful-dnd
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

let initialState = {
  linksList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LINKS_LIST:
      return {
        ...state,
        linksList: action.payload,
      };
    case UPDATE_LINK:
      return {
        ...state,
        linksList: action.payload,
      };
    case ADD_LINK:
      return {
        ...state,
        linksList: [...state.linksList, action.payload],
      };
    case MOVE_LINK:
    case MOVE_LINK_ERROR:
      return {
        ...state,
        linksList: reorder(
          state.linksList,
          action.payload.startIndex,
          action.payload.endIndex,
        ),
      };
    case REMOVE_LINK:
      return {
        ...state,
        linksList: state.linksList.filter(el => el.id !== action.payload.id),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/links/reducer.js